module.exports = __webpack_public_path__ + "kids_halloween_1.jpg";